import { Controller } from "stimulus"


class HomepageNavController extends Controller {
  static targets = [
    'homepageNavAnchor',
    'homepageLogoColor',
    'homepageLogoWhite',
    'navBar',
    'navBarMF'
  ]

  connect() {
    this.updateNavStyleOnPosition();
  }

  onScroll(event) {
    this.updateNavStyleOnPosition();
  }

  updateNavStyleOnPosition() {
    const height = this.__checkNavPosition();

    if(height >= 0) {
      this.__addNewNavStyles();
    } else {
      this.__removeNewNavStyles();
    }
  }

  __checkNavPosition() {
    return this.homepageNavAnchorTarget.getBoundingClientRect().bottom - 50;
  }

  __addNewNavStyles() {
    this.homepageLogoColorTargets.forEach(logo => {
      logo.classList.add('t-hidden');
    })

    this.homepageLogoWhiteTargets.forEach(logo => {
      logo.classList.remove('t-hidden');
    })

    this.navBarTargets.forEach(nav_bar => {
      nav_bar.classList.add('new-nav-style');
    })

    this.navBarMFTargets.forEach(nav_bar => {
      nav_bar.classList.add('mf-new-nav-style');
    })
  }

  __removeNewNavStyles() {
    this.homepageLogoColorTargets.forEach(logo => {
      logo.classList.remove('t-hidden');
    })

    this.homepageLogoWhiteTargets.forEach(logo => {
      logo.classList.add('t-hidden');
    })

    this.navBarTargets.forEach(nav_bar => {
      nav_bar.classList.remove('new-nav-style');
    })

    this.navBarMFTargets.forEach(nav_bar => {
      nav_bar.classList.remove('mf-new-nav-style');
    })
  }
}

export default HomepageNavController;
